import type { Components } from "react-markdown";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { transformMarkdownUrl } from "@/shared/markdown";

const components: Components = {
  img: () => null,
  a: ({ href, children }) => {
    const safe = href ? transformMarkdownUrl(href) : "";
    if (!safe) return <span>{children}</span>;
    const external = safe.startsWith("http://") || safe.startsWith("https://");
    return (
      <a href={safe} {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}>
        {children}
      </a>
    );
  },
};

export function MarkdownBody({ markdown }: { markdown: string }) {
  return (
    <div className="prose prose-sm max-w-none text-foreground prose-headings:font-display prose-a:text-foreground">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        urlTransform={transformMarkdownUrl}
        skipHtml
        components={components}
      >
        {markdown}
      </ReactMarkdown>
    </div>
  );
}
